/**
 * DUB Click Tracking Utilities
 * Handles extraction and storage of DUB click IDs from URL parameters
 */

const DUB_CLICK_ID_KEY = 'dub_click_id';

/**
 * Extract DUB click ID from current URL
 */
export const getDubClickIdFromUrl = (): string | null => {
  if (typeof window === 'undefined') return null;

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('dub_id');
};

/**
 * Store DUB click ID in localStorage
 */
export const storeDubClickId = (dclid: string): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(DUB_CLICK_ID_KEY, dclid);
};

/**
 * Get stored DUB click ID from localStorage
 */
export const getStoredDubClickId = (): string | null => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(DUB_CLICK_ID_KEY);
};

/**
 * Clear stored DUB click ID
 */
export const clearDubClickId = (): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(DUB_CLICK_ID_KEY);
};

/**
 * Initialize DUB tracking - extract from URL and store if present
 * @returns The extracted click ID if found, null otherwise
 */
export const initDubTracking = (): string | null => {
  const dclid = getDubClickIdFromUrl();
  if (dclid) {
    storeDubClickId(dclid);
  }
  return dclid;
};
